<template>
    <div class="c-form_list">
        <div class="c-form_list__add">
            <form-input
                :label="label"
                v-model="newItem"
                class="c-form_list__add-input"
                btn="green"
                btnLabel="Dodaj"
                btn-has-loader
                :btn-loading="isLoading"
                @click="addItem"
                :error="error"
                :speech-to-text="speechToText">
            </form-input>
        </div>
        <ol
            class="c-form_list__list"
            :class="{ 'c-form_list__list--narrow' : narrowList }">
            <form-list-item
                v-for="item in value"
                :key="item.id || item"
                @delete="deleteItem(item)">
                {{ item.name || item }}
            </form-list-item>
        </ol>
    </div>
</template>


<script>

import FormInput from './FormInput'
import FormErrorMsg from './FormErrorMsg'
import FormListItem from './FormListItem'

export default {

    name: 'FormList',

    props: {
        name: String,
        value: Array,
        label: String,
        objectList: Boolean,
        max: [String, Number],
        narrowList: Boolean,
        isLoading: Boolean,
        speechToText: Boolean
    },

    data() {
        return {
            newItem: '',
            error: ''
        }
    },

    methods: {
        deleteItem(item) {
            if (!this.objectList) {
                var itemId = this.value.indexOf(item)
                this.value.splice(itemId, 1)
                this.$emit('input', this.value)
            } else {
                this.$emit('delete', item.id)
            }
            this.error = ''
        },
        addItem(newItem) {
            if (newItem !== '' && !this.isFull() && !this.itemExist(newItem)) {
                if (!this.objectList) {
                    this.value.push(newItem)
                    this.$emit('input', this.value)
                } else {
                    this.$emit('add', newItem)
                }
                this.newItem = ''
            }
        },
        itemExist(newItem) {
            newItem = newItem.trim().toLowerCase()

            var sameItems = this.value.filter((item) => {
                let val = item.name || item
                val = val.toLowerCase()
                return (val === newItem)
            })

            if (sameItems.length) {
                this.error = 'Taki element już istnieje'
                return true
            }
            this.error = ''
            return false
        },
        isFull() {
            if (!this.max)
                return false

            if (parseInt(this.max) <= (this.value.length)) {
                this.error = `Maksymalna ilość elementów to ${this.max}`
                return true
            }

            return false
        }
    },

    components: {
        FormInput,
        FormErrorMsg,
        FormListItem
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_list {
    width: 100%;
    margin-bottom: 1rem;
    overflow: hidden;

    &__add {
        display: flex;
        width: 100%;
        max-width: 450px;

        &-input {
            width: 100%;
        }
        &-btn {
            margin-left: 0.5rem;

            @include bp(490px) {
                text-indent: -9999px;
                background-image: url('#{$icons}/plus.svg');
                background-position: center;
                background-size: 18px;
                background-repeat: no-repeat;
                padding: 0;
                flex-shrink: 0;
                width: 40px;
                margin-left: 0px;
                border-radius: 0 0.25rem 0.25rem 0;

                &:hover {
                    background-color: $c-primary;
                }
            }
        }
    }
    &__list {
        margin-top: 1.4rem;
        width: 100%;
        counter-reset: prokrastynacja;

        &--narrow {
            max-width: 450px;
        }
    }
}

</style>
